import RequestsComponent from "../../components/RequestsComponent";
import { connect } from "react-redux";
import { getManagerRequests, costConfirm, costCancel, confirmAllCosts } from "../actions/manager";
import swal from "sweetalert2";
import i18n from "i18next";

var mapStateToProps = (state, ownProps) => {
  return {
    employeeList: state.employees.employeeList.employeeListManagerApproval,
    isManager: state.login.employeeInfo.isManager,
    requestsList: state.managers.data,
    accessToken: state.login.employeeInfo.accessToken,
    filter: state.managers.filter,
    employeeID: state.login.employeeInfo.uid,
    requestCount: state.managers.data.length || 0
  }
}
var mapDispatchToProps = (dispatch) => {
  return {
    costConfirmAction: (user, costData, accessToken, employeeFilter, cb) => {
      dispatch(costConfirm({
        'user': user,
        'costData': costData,
        'accessToken': accessToken,
        'employeeFilter': employeeFilter,
        'cb': cb
      }));
    },
    costCancelAction: (accessToken, user, costData, cb) => {
      cb();
      swal({
        title: i18n.t("areYouSure"),
        text: i18n.t("costFormWillRejected"),
        type: 'warning',
        input: "textarea",
        inputPlaceholder: i18n.t("enterDescription"),
        inputValidator: function (value) {
          return new Promise((resolve, reject) => {
            if (!value)
            reject(i18n.t("doNotLeaveDescriptionEmpty"))
            else
              resolve()
          })
        },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t("yes"),
        cancelButtonText: i18n.t("cancelButton")
      }).then(function (costDescription) {
        dispatch(costCancel({ 'accessToken': accessToken, 'user': user, 'costData': costData, 'costDescription': costDescription }));
      }).catch((e) => {
        console.log(e)
      });
    },
    confirmAllCostsButtonAction: (accessToken, month, year, costStatus, employeeId) => {
      dispatch(confirmAllCosts({
        'accessToken': accessToken,
        'month': month, 
        'year': year,
        'costStatus': costStatus, 
        'employeeId': employeeId
      }));
    },
    getManagerRequests: (accessToken, employeeId, month, year, costStatus, cb) => {
      dispatch(getManagerRequests({
        'accessToken': accessToken,
        'employeeId': employeeId,
        'month': month,
        'year': year,
        'costStatus': costStatus,
        'cb': cb
      }
      ));
    }
  }
};
const Requests = connect(mapStateToProps, mapDispatchToProps)(RequestsComponent);
export default Requests;
